import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import {
  user,
  escala,
  pesquisa,
  receitas_despesas,
  vuetableState,
  emendas_parlamentares,
  eleicoes_conselho,
  plano_governo,
  localizacao_unidades
} from './modules'
import { actions } from './actions'
import { mutations } from './mutations'

Vue.use(Vuex)

const state = {
  initialized: false,
  isLogged: !!localStorage.getItem('daUser')
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      key: 'dados_abertos',
      paths: ['isLogged', 'user', 'receitas_despesas.receitas_proprias'],
      storage: window.localStorage
    })
  ],
  state,
  mutations,
  actions,
  modules: {
    user,
    escala,
    pesquisa,
    receitas_despesas,
    vuetableState,
    emendas_parlamentares,
    eleicoes_conselho,
    plano_governo,
    localizacao_unidades
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js